const stateMainScreen = {
    "gameSelected": null,
    "messages": {
        "Survive The Internet (Party Pack 4)": {
            "name": "Survive The Internet",
            "longName": "Survive The Internet (Party Pack 4)",
            "partyPack": "Party Pack 4",
            "Min players": 3,
            "Max players": 8,
            "Variants": [
                "survive",
                "survive the internet",
                "sti"
            ],
            "username": "dcpesses",
            "time": 1628112883959,
            "locked": false,
            "chosen": false
        },
        "Quiplash (Any Version)": {
            "name": "Quiplash",
            "longName": "Quiplash (Any Version)",
            "partyPack": "Any Version",
            "Min players": 3,
            "Max players": 8,
            "Variants": [
                "quiplash",
                "quip",
                "ql"
            ],
            "username": "dcpesses",
            "time": 1628113055677,
            "locked": false,
            "chosen": false
        },
        "You Don't Know Jack (Party Pack 5)": {
            "name": "You Don't Know Jack",
            "longName": "You Don't Know Jack (Party Pack 5)",
            "partyPack": "Party Pack 5",
            "Min players": 1,
            "Max players": 8,
            "Variants": [
                "ydkj 2",
                "ydkj fs",
                "ydkjfs",
                "you dont know jack 2",
                "you don't know jack 2",
                "you don't know jack full stream",
                "you don't know jack full steam",
                "you don't know jack: full stream"
            ],
            "username": "dcpesses",
            "time": 1628114634007,
            "locked": false,
            "chosen": false
        },
        "Mad Verse City (Party Pack 5)": {
            "name": "Mad Verse City",
            "longName": "Mad Verse City (Party Pack 5)",
            "partyPack": "Party Pack 5",
            "Min players": 3,
            "Max players": 8,
            "Variants": [
                "mvc",
                "madverse",
                "mad verse",
                "madversecity",
                "mad verse city"
            ],
            "username": "dcpesses",
            "time": 1628114645263,
            "locked": false,
            "chosen": false
        },
        "Monster Seeking Monster (Party Pack 4)": {
            "name": "Monster Seeking Monster",
            "longName": "Monster Seeking Monster (Party Pack 4)",
            "partyPack": "Party Pack 4",
            "Min players": 3,
            "Max players": 7,
            "Variants": [
                "msm",
                "monster seeking monster",
                "monster seeking monsters",
                "monsters seeking monsters"
            ],
            "username": "dcpesses",
            "time": 1628114646991,
            "locked": false,
            "chosen": false
        },
        "Blather 'Round (Party Pack 7)": {
            "name": "Blather 'Round",
            "longName": "Blather 'Round (Party Pack 7)",
            "partyPack": "Party Pack 7",
            "Min players": 2,
            "Max players": 6,
            "Variants": [
                "blather",
                "blather round",
                "blather 'round",
                "blatherround",
                "blatheround"
            ],
            "username": "dcpesses",
            "time": 1628114733155,
            "locked": false,
            "chosen": false
        },
        "Talking Points (Party Pack 7)": {
            "name": "Talking Points",
            "longName": "Talking Points (Party Pack 7)",
            "partyPack": "Party Pack 7",
            "Min players": 3,
            "Max players": 8,
            "Variants": [
                "talking points",
                "talkingpoints",
                "talk points"
            ],
            "username": "dcpesses",
            "time": 1628114749438,
            "locked": false,
            "chosen": false
        },
        "Gartic Phone (Standalone)": {
            "name": "Gartic Phone",
            "longName": "Gartic Phone (Standalone)",
            "partyPack": "Standalone",
            "Min players": 4,
            "Max players": 30,
            "Variants": [
                "gartic phone",
                "garticphone",
                "garlic phone",
                "garlicphone",
                "gartic",
                "garlic"
            ],
            "username": "dcpesses",
            "time": 1628114761558,
            "locked": false,
            "chosen": false
        },
        "Drawful (Any Version)": {
            "name": "Drawful",
            "longName": "Drawful (Any Version)",
            "partyPack": "Any Version",
            "Min players": 3,
            "Max players": 8,
            "Variants": [
                "drawful",
                "drawfull",
                "draw full"
            ],
            "username": "dcpesses",
            "time": 1628114769626,
            "locked": false,
            "chosen": false
        },
        "Words on Stream (Standalone)": {
            "name": "Words on Stream",
            "longName": "Words on Stream (Standalone)",
            "partyPack": "Standalone",
            "Min Players": 4,
            "Max Players": 50,
            "Variants": [
                "words on stream",
                "word on stream",
                "words stream",
                "word stream",
                "words",
                "wos"
            ],
            "username": "dcpesses",
            "time": 1628114772430,
            "locked": false,
            "chosen": false
        },
        "Gartic on Stream (Standalone)": {
            "name": "Gartic on Stream",
            "longName": "Gartic on Stream (Standalone)",
            "partyPack": "Standalone",
            "Min Players": 4,
            "Max Players": 50,
            "Variants": [
                "gartic on stream",
                "garlic on stream",
                "garlic stream",
                "gartic stream",
                "gos"
            ],
            "username": "dcpesses",
            "time": 1628114776310,
            "locked": false,
            "chosen": false
        },
        "The Devils and the Details (Party Pack 7)": {
            "name": "The Devils and the Details",
            "longName": "The Devils and the Details (Party Pack 7)",
            "partyPack": "Party Pack 7",
            "Min players": 3,
            "Max players": 8,
            "Variants": [
                "devils",
                "devils in details",
                "devils and details",
                "devils & details",
                "devil's in details",
                "devil's and details",
                "devil's & details",
                "devils in the details",
                "devils and the details",
                "devils & the details",
                "devil's in the details",
                "devil's and the details",
                "devil's & the details",
                "the devils in the details",
                "the devils and the details",
                "the devils & the details",
                "the devil's in the details",
                "the devil's and the details",
                "the devil's & the details"
            ],
            "username": "dcpesses",
            "time": 1628114937776,
            "locked": false,
            "chosen": false
        },
        "Fibbage: Enough About You (Party Pack 4)": {
            "name": "Fibbage: Enough About You",
            "longName": "Fibbage: Enough About You (Party Pack 4)",
            "partyPack": "Party Pack 4",
            "Min players": 2,
            "Max players": 8,
            "Variants": [
                "eay",
                "enough about you",
                "feay",
                "fibbage eay",
                "fibbage: eay",
                "fibbage enough about you",
                "fibbage: enough about you"
            ],
            "username": "dcpesses",
            "time": 1628114942915,
            "locked": false,
            "chosen": false
        },
        "Champ'd Up (Party Pack 7)": {
            "name": "Champ'd Up",
            "longName": "Champ'd Up (Party Pack 7)",
            "partyPack": "Party Pack 7",
            "Min players": 3,
            "Max players": 8,
            "Variants": [
                "champd",
                "champed",
                "champd up",
                "champ'd",
                "champ'd up",
                "champed up"
            ],
            "username": "dcpesses",
            "time": 1628114981572,
            "locked": false,
            "chosen": false
        },
        "Civic Doodle (Party Pack 4)": {
            "name": "Civic Doodle",
            "longName": "Civic Doodle (Party Pack 4)",
            "partyPack": "Party Pack 4",
            "Min players": 3,
            "Max players": 8,
            "Variants": [
                "civic doodle",
                "civicdoodle",
                "civic"
            ],
            "username": "dcpesses",
            "time": 1628115017116,
            "locked": false,
            "chosen": false
        },
        "Trivia Murder Party 2 (Party Pack 6)": {
            "name": "Trivia Murder Party 2",
            "longName": "Trivia Murder Party 2 (Party Pack 6)",
            "partyPack": "Party Pack 6",
            "Min players": 1,
            "Max players": 8,
            "Variants": [
                "tmp2",
                "tmp 2",
                "trivia murder party 2"
            ],
            "username": "dcpesses",
            "time": 1628118545790,
            "locked": false,
            "chosen": false
        },
        "Quiplash 3 (Party Pack 7)": {
            "name": "Quiplash 3",
            "longName": "Quiplash 3 (Party Pack 7)",
            "partyPack": "Party Pack 7",
            "Min players": 3,
            "Max players": 8,
            "Variants": [
                "ql3",
                "ql 3",
                "quip 3",
                "quip3",
                "quiplash 3",
                "quiplash3"
            ],
            "username": "dcpesses",
            "time": 1628121075780,
            "locked": false,
            "chosen": false
        },
        "Trivia Murder Party 1 (Party Pack 3)": {
            "name": "Trivia Murder Party 1",
            "longName": "Trivia Murder Party 1 (Party Pack 3)",
            "partyPack": "Party Pack 3",
            "Min players": 1,
            "Max players": 8,
            "Variants": [
                "tmp1",
                "tmp 1",
                "trivia murder party 1"
            ],
            "username": "dcpesses",
            "time": 1628122719930,
            "locked": false,
            "chosen": false
        }
    },
    "colors": [
        "#75a5e5",
        "#847cef",
        "#74aee0",
        "#86efed",
        "#63bbd8",
        "#c9d8ff",
        "#97ecef",
        "#bcefff",
        "#9caff4",
        "#b9a4f2",
        "#9fbbfc",
        "#affffc",
        "#a1bef4",
        "#7ee7fc",
        "#97c1ef",
        "#a4a4fc",
        "#a4a5f4",
        "#b7f1ff",
        "#79bdfc",
        "#6885dd",
        "#98e1f2",
        "#aac1ff",
        "#a583fc",
        "#8991e5",
        "#6edddd",
        "#a7b7ef",
        "#74e2e8",
        "#9c9af9",
        "#9dd5f2",
        "#6a73ed",
        "#b19df9",
        "#88eaea",
        "#6b91ef",
        "#9de1f9",
        "#7691fc",
        "#d0c4fc",
        "#c9d7ff",
        "#84a7ed",
        "#809bfc",
        "#63d0d8",
        "#b8cbfc",
        "#a3a0ff",
        "#b4f4f7",
        "#9c9efc",
        "#8ae8f7",
        "#7985ea",
        "#7876e8",
        "#cfc2fc",
        "#bfcfff",
        "#92a9f4",
        "#d0c2fc",
        "#adc9f7",
        "#767ce0",
        "#95a1f9",
        "#a286f4",
        "#8085ed",
        "#c4c9fc",
        "#7c8ff9",
        "#7079f9",
        "#aaa5ff",
        "#8db7e8",
        "#9e94e8",
        "#a5ffff",
        "#76ade8",
        "#a9f5fc",
        "#a0a5ff",
        "#9cbffc",
        "#8fa2e8",
        "#8eeeff",
        "#88ccf7",
        "#b0f2f4",
        "#8e7fef",
        "#aef9f8",
        "#8beef9",
        "#7a8ef4",
        "#c7c4fc",
        "#7b87f2",
        "#7b77ea",
        "#859be5",
        "#7191e8",
        "#aadaef",
        "#b1aaf7",
        "#80bff7",
        "#95e0f4",
        "#a3e5ed",
        "#91a1f2",
        "#c0c4f9",
        "#7a90f4",
        "#85def2",
        "#87f2ee",
        "#cac6ff",
        "#76c3f7",
        "#c2dcfc",
        "#a2a2f9",
        "#ccd7ff",
        "#978fef",
        "#8d77e5",
        "#bad0fc",
        "#ccf7ff"
    ],
    "counter": 26,
    "history": [
        {
            "name": "Zeeple Dome",
            "longName": "Zeeple Dome (Party Pack 5)",
            "partyPack": "Party Pack 5",
            "Min players": 1,
            "Max players": 6,
            "Variants": [
                "zeeple",
                "zeeple dome",
                "zeepledome"
            ],
            "username": "dcpesses",
            "time": 1628114757634,
            "locked": false,
            "chosen": false,
            "override": false
        },
        {
            "name": "Split the Room",
            "longName": "Split the Room (Party Pack 5)",
            "partyPack": "Party Pack 5",
            "Min players": 3,
            "Max players": 8,
            "Variants": [
                "split the room",
                "splittheroom",
                "split room",
                "room split",
                "split",
                "str"
            ],
            "username": "dcpesses",
            "time": 1628114989864,
            "locked": false,
            "chosen": false,
            "override": false
        },
        {
            "name": "Fibbage 3",
            "longName": "Fibbage 3 (Party Pack 4)",
            "partyPack": "Party Pack 4",
            "Min players": 2,
            "Max players": 8,
            "Variants": [
                "fibbage 3",
                "fibbage3"
            ],
            "username": "dcpesses",
            "time": 1628114666823,
            "locked": false,
            "chosen": false,
            "override": false
        },
        {
            "name": "Trivia Murder Party",
            "longName": "Trivia Murder Party (Any Version)",
            "partyPack": "Any Version",
            "Min players": 1,
            "Max players": 8,
            "Variants": [
                "tmp",
                "trivia murder party"
            ],
            "username": "dcpesses",
            "time": 1628106145996,
            "locked": false,
            "chosen": false,
            "override": false
        }
    ],
    "nextGameIdx": 0,
    "showPlayerSelect": false,
    "userLookup": {
        "dcpesses": {
            "color": "#1E90FF",
            "user-id": "473294395",
            "username": "dcpesses"
        }
    }
};

const statePlayerSelect = {
    "interested": [
        {
            "username": "player6",
            "isPrioritySeat": false
        },
        {
            "username": "player3",
            "isPrioritySeat": false
        },
        {
            "username": "player9"
        },
        {
            "username": "dcpesses"
        }
    ],
    "playing": [
        {
            "username": "player1",
            "isPrioritySeat": true
        },
        {
            "username": "player7",
            "isPrioritySeat": false
        },
        {
            "username": "player8"
        },
        {
            "username": "player5",
            "isPrioritySeat": true
        },
        {
            "username": "player2",
            "isPrioritySeat": true
        }
    ],
    "joined": [],
    "streamerSeat": true,
    "isQueueOpen": true,
    "columnWidth": 634
}

export {
    stateMainScreen as MainScreen,
    statePlayerSelect as PlayerSelect
};
